export const imageRoute = [ process.env.VUE_APP_IMG ]
export const fileRoute  = [ process.env.VUE_APP_FILE ]